import { subscribeChannel, publishChannel } from './channelUtils';

export function sendPontosBatch(pontos) {
    
    publishChannel('pontos-iti-sync', { pontos });

}

export function sendPontoUpsert(ponto) {
    
    publishChannel('pontos-iti-upsert', ponto);

}

export function sendPontoDelete({ CODIGO_INTEGRACAO, SEQUENCIA }) {
    
    publishChannel('pontos-iti-delete', { CODIGO_INTEGRACAO, SEQUENCIA });

}

export function sendPontosCodigoDelete(codigo) {
    
    publishChannel('pontos-codigo-delete', codigo);
}

export function sendPontosSnapshot({ pontos }) {

    publishChannel('pontos-iti-snapshot', { pontos });

}

export function sendPontosReset() {
    publishChannel('pontos-iti-reset');
}

export function listenPontosItinerario(callback) {

    return subscribeChannel((event) => {

        const { tipo, payload } = event.data;

        if (
            tipo !== 'pontos-iti-sync' &&
            tipo !== 'pontos-iti-upsert' &&
            tipo !== 'pontos-iti-delete' &&
            tipo !== 'pontos-codigo-delete' &&
            tipo !== 'pontos-iti-snapshot' &&
            tipo !== 'pontos-iti-reset'
        ) {
            return;
        }

        callback({ tipo, payload });

    });

}